import { getAttribution } from 'affiliate-marketing-utils';
let attribution;
try {
  attribution = getAttribution();
} catch (error) {
  attribution = null;
}
export function getImpactAdditionalParams() {
  return attribution;
}